{
  "1 à 5": "1 to 5",
  "A chassé le plus de bad vibes": "Chased off the most bad vibes",
  "A chassé les boss": {
    "one": "Chased off the boss",
    "other": "Chased off the bosses"
  },
  "A ramassé le plus de vibes": "Picked up the most vibes",
  "A relevé l’équipe": "Got the team back up",
  "Agir": "Actions",
  "Agrès": "Props",
  "Alliés soignés": "Allies healed",
  "Alt": "Alt",
  "Alt Gr": "Right Alt",
  "Ambyss": "Ambyss",
  "Anneaux solaires": "Solar Rings",
  "Apprendre à jouer": "Learn to play",
  "Approche une bad vibe : tu tires tout seul": "Get close to a bad vibe: you fire on your own",
  "Appuie sur Entrée ou sur A pour rejoindre": "Press Enter or A to join",
  "Appuie…": "Press…",
  "Après chaque kick, trois étincelles qui transpercent.": "After each kick, three sparks that pierce through.",
  "Après le dernier boss, la nuit continue": "After the last boss, the night goes on",
  "Arc-en-ciel du drop": "Drop Rainbow",
  "Assiettes chinoises": "Spinning Plates",
  "Attire": "Pulls",
  "Aucun salon ne porte ce code": "No room has this code",
  "Automatique": "Automatic",
  "Autre": "Other",
  "Avant de lancer": "Before you start",
  "Avec tes amis": "With your friends",
  "B2B : {recipe}": "B2B: {recipe}",
  "Backstage": "Backstage",
  "Bad vibes": "Bad vibes",
  "Bad vibes dissipées": "Bad vibes cleared",
  "Baisser le son": "Turn the sound down",
  "Balaie la foule de loin avec ses poi lumineux. Fragile.": "Sweeps the crowd from afar with glowing poi. Fragile.",
  "Balaie un arc d'une ligne de lumière qui dissout les bad vibes.": "Sweeps an arc with a line of light that dissolves the bad vibes.",
  "Banane": "Bum Bag",
  "Bas": "Down",
  "Baskets légères": "Light Sneakers",
  "Bonnes ondes": "Good Vibrations",
  "Boss": "Bosses",
  "Boss vaincu": "Boss down",
  "Boucle VJ": "VJ Loop",
  "Boule à facettes": "Disco Ball",
  "Bouton {number}": "Button {number}",
  "Boutons par défaut remis.": "Default buttons restored.",
  "Bras grands ouverts": "Arms Wide Open",
  "Break": "Break",
  "Brume du lac": "Lake Mist",
  "Bug": "Bug",
  "Bâton de feu": "Fire Staff",
  "Bâton du diable": "Devil Stick",
  "Caisson de basse": "Subwoofer",
  "Ce bouton garde son rôle, choisis-en un autre.": "This button keeps its job, pick another one.",
  "Ce code est déjà pris, réessaie": "This code is taken, try again",
  "Ce code n’est pas valide": "This code isn’t valid",
  "Ce que tu as vécu, ce que tu attendais, ce que tu changerais.": "What you lived, what you expected, what you would change.",
  "Cerceaux": "Hoops",
  "Cette touche garde son rôle, choisis-en une autre.": "This key keeps its job, pick another one.",
  "Chacun prend une place avec son clavier ou sa manette.": "Everyone takes a seat with their keyboard or gamepad.",
  "Chaque dash laisse ta traînée au sol deux mesures.": "Each dash leaves your trail on the ground for two bars.",
  "Charge": "Charge",
  "Choisi": "Chosen",
  "Choisir": "Choose",
  "Choisir la scène": "Pick the stage",
  "Choisir un piège": "Pick a trap",
  "Choisis d’abord le type de ton avis.": "First pick what your feedback is about.",
  "Choisis la scène": "Pick the stage",
  "Choisis tes touches et tes boutons": "Choose your keys and buttons",
  "Choisis ton amélioration": "Pick your upgrade",
  "Choisis ton perso": "Pick your character",
  "Choix de la scène": "Stage choice",
  "Choix du perso": "Character choice",
  "Choix d’amélioration": "Upgrade choice",
  "Classe": "Class",
  "Classe précédente": "Previous class",
  "Classe suivante": "Next class",
  "Classe · {className}": "Class · {className}",
  "Classes": "Classes",
  "Clavier et souris": "Keyboard and mouse",
  "Clic droit": "Right click",
  "Clic gauche": "Left click",
  "Clic molette": "Middle click",
  "Code du salon": "Room code",
  "Colle le code ici": "Paste the code here",
  "Connexion impossible ({message})": "Can’t connect ({message})",
  "Connexion perdue": "Connection lost",
  "Console de mixage": "Mixing Desk",
  "Contexte de la partie": "Game context",
  "Contrôles": "Controls",
  "Copie impossible ici. Ton avis reste dans l’onglet GitHub.": "Can’t copy here. Your feedback stays in the GitHub tab.",
  "Copie impossible ici. Ton texte est sélectionné : copie-le à la main.": "Can’t copy here. Your text is selected: copy it by hand.",
  "Copier": "Copy",
  "Copier le lien": "Copy the link",
  "Copié dans le presse-papiers.": "Copied to the clipboard.",
  "Coupé": "Muted",
  "Croix": "D-pad",
  "Crée un salon pour inviter tes amis, ou rejoins le leur avec son code.": "Create a room to invite your friends, or join theirs with its code.",
  "Créer un salon": "Create a room",
  "Ctrl": "Ctrl",
  "Ctrl droite": "Right Ctrl",
  "Câble d'or": "Golden Cable",
  "C’est plutôt": "It’s about",
  "Dash": "Dash",
  "Debout": "Standing",
  "Des spores, à porter à un géant": "Spores, to carry to a giant",
  "Deux bâtons frappent tout autour de toi à chaque temps.": "Two staffs hit all around you on every beat.",
  "Deux éventails tournent autour de toi sans jamais s’arrêter.": "Two fans spin around you and never stop.",
  "Deuxième souffle": "Second Wind",
  "Diabolo": "Diabolo",
  "Didacticiel": "Tutorial",
  "Double bâton": "Double Staff",
  "Double faisceau": "Double Beam",
  "Double tempo": "Double Time",
  "Downtempo, dub": "Downtempo, dub",
  "Droite": "Right",
  "Drop": "Drop",
  "Débriefe ton set sur Discord": "Talk your set over on Discord",
  "Début": "Home",
  "Défends le sound system jusqu’au lever du soleil.": "Defend the sound system until sunrise.",
  "Défense": "Defense",
  "Départ": "Start",
  "Déplace-toi": "Move around",
  "Elle vide l'énergie de tout ce qui brille.": "Drains the energy out of everything that shines.",
  "En attente de l’hôte": "Waiting for the host",
  "En attente de {players}": "Waiting for {players}",
  "En attente d’un joueur": "Waiting for a player",
  "En ligne": "Online",
  "En ligne, la pause n’arrête pas le set : ton personnage reste immobile pendant que les autres jouent.": "Online, pausing doesn’t stop the set: your character stands still while the others play.",
  "Enceintes": "Speakers",
  "Enceintes branchées": "Speakers plugged in",
  "Entrée": "Enter",
  "Envoie le code ou le lien à tes amis, puis lance le set.": "Send the code or the link to your friends, then start the set.",
  "Envoie une onde de basse sur chaque temps et repousse les bad vibes.": "Sends a bass wave on every beat and pushes the bad vibes back.",
  "Envoyer sur GitHub": "Send on GitHub",
  "Espace": "Space",
  "Fais un dash": "Dash",
  "Fermer": "Close",
  "Fin": "End",
  "Fin de partie": "End of the game",
  "Frappe autour": "Hits around",
  "Frappe devant": "Hits ahead",
  "Frappe loin": "Hits far",
  "Frisbee": "Frisbee",
  "Frisbees en passes": "Frisbee Passes",
  "Full festival": "Full festival",
  "Fusion": "Fusion",
  "Gauche": "Left",
  "Glisse sur l’arène pour te déplacer": "Drag on the arena to move",
  "Glisser son bouton": "Drag its button",
  "Glisser sur l’arène": "Drag on the arena",
  "Goa des étoiles": "Starlight Goa",
  "Générique": "General",
  "Haut": "Up",
  "Hôte": "Host",
  "Idée": "Idea",
  "Il attire les bad vibes, puis les repousse d’une onde.": "It draws the bad vibes in, then pushes them back with a wave.",
  "Il enrôle les bad vibes en ronde autour de lui : elles prennent les coups.": "They rope the bad vibes into a circle pit around them, which takes the hits.",
  "Il filme la scène et éblouit doucement la zone de son écran.": "Films the stage and gently dazzles the area their screen points at.",
  "Il fonce droit sur la scène et bouscule qui se met en travers.": "Rushes straight at the stage and shoves whoever gets in the way.",
  "Il fonce sur tes vibes au sol, les vole, puis détale si tu le poursuis.": "Dashes for your vibes on the ground, steals them, then bolts if you give chase.",
  "Il frappe en arc devant toi à chaque temps.": "It sweeps an arc in front of you on every beat.",
  "Il frappe à l’aller, revient soigner un allié.": "It hits on the way out, then comes back to heal an ally.",
  "Il ne va pas bien : reste à son contact une mesure pour l'aider.": "They’re not doing well: stay by their side for a bar to help them.",
  "Il reste loin et balance des bouteilles qui ralentissent qui les reçoit.": "Keeps their distance and chucks bottles that slow down whoever they hit.",
  "Il s'accroche à toi et te ralentit jusqu'à ce qu'on le décroche.": "Hangs on to you and slows you down until someone shakes them off.",
  "Il souffle, et tout ce qui est léger dérive.": "Blows hard, and everything light drifts.",
  "Il surgit de partout à la fois, faible seul mais jamais seul.": "Pops up from everywhere at once, weak alone but never alone.",
  "Il va plus loin et plus vite, puis revient soigner un allié.": "It flies farther and faster, then comes back to heal an ally.",
  "Il veut couper le son avant l'heure.": "Wants to cut the sound before it’s time.",
  "Il éteint les bonus de qui reste trop près : vise-le en priorité.": "Switches off the boosts of anyone who stays too close: take them out first.",
  "Inser": "Insert",
  "Interruption": "Interruption",
  "Inverser les sticks": "Swap the sticks",
  "Invité": "Guest",
  "Jambes de danseur": "Dancer’s Legs",
  "Jauge": "Gauge",
  "Jeu complet": "Full game",
  "Jeu web léger de survie coopérative dans un festival de psytrance.": "A light co-op survival web game set at a psytrance festival.",
  "Joindre le contexte": "Attach the context",
  "Joue en continu": "Plays non-stop",
  "Jouer": "Play",
  "Joueur {number}": "Player {number}",
  "Jusqu’à 4 joueurs": "Up to 4 players",
  "Kiff": "Bliss",
  "L'Arnaqueur": "The Hustler",
  "L'Hygie": "The Hygie",
  "L'Intolérant": "The Bigot",
  "La Batterie à plat": "The Dead Battery",
  "La Forêt": "The Forest",
  "La Grenouille acide": "The Acid Frog",
  "La Luxiole": "The Luxiole",
  "La musique s’arrête": "The music stops",
  "La partie a déjà commencé": "The game has already started",
  "La piste t’attend": "The floor is waiting",
  "La soirée d'ouverture": "Opening Night",
  "Lance le set": "Starts the set",
  "Lance ta spéciale": "Use your special",
  "Lancer la nuit": "Start the night",
  "Lancer le festival": "Start the festival",
  "Lancer le set": "Start the set",
  "Lancé sur le 1, il retombe sur les bad vibes et claque.": "Thrown on the 1, it lands on the bad vibes with a bang.",
  "Langue": "Language",
  "Langues du jeu": "Game languages",
  "Laser": "Laser",
  "Le Babacool": "The Hippie",
  "Le Bavard": "The Chatterbox",
  "Le Cercle acid": "The Acid Circle",
  "Le Circadien": "The Circadian",
  "Le Collant": "The Clinger",
  "Le Coup de vent": "The Gust",
  "Le Couvre-feu": "The Curfew",
  "Le Céleste": "The Celestial",
  "Le Dome": "The Dome",
  "Le Désagréable": "The Grump",
  "Le Dôme chill": "The Chill Dome",
  "Le Fatigué": "The Sleepyhead",
  "Le Festivalier en détresse": "The Raver in Distress",
  "Le Filmeur": "The Filmer",
  "Le Jongleur": "The Juggler",
  "Le Kiffeur": "The Reveler",
  "Le Mâle alpha": "The Alpha Male",
  "Le Méprisant": "The Snob",
  "Le Nounours": "The Nounours",
  "Le Pogo": "The Mosher",
  "Le Poussin": "The Chick",
  "Le Random": "The Random",
  "Le Sportif": "The Athlete",
  "Le Sub": "The Sub",
  "Le Super fan": "The Superfan",
  "Le Tatoué": "The Inked",
  "Le Veilleur aux lucioles": "The Firefly Keeper",
  "Le Zombie": "The Zombie",
  "Le boss lâche une relique": "The boss drops a relic",
  "Le formulaire GitHub est ouvert": "The GitHub form is open",
  "Le jeu se recharge": "The game reloads",
  "Le lien avec les autres joueurs est coupé.": "The link with the other players is cut.",
  "Le lève-tôt du petit matin : abats-le, il se relève une fois.": "The early-morning straggler: knock them down, they get up once.",
  "Le poser ailleurs": "Place it elsewhere",
  "Le salon existe, mais vos réseaux n’arrivent pas à se joindre": "The room exists, but your networks can’t reach each other",
  "Le set continue": "The set goes on",
  "Le set est allé au bout, puis le sound system a tenu {duration} de sans-fin. On y retourne ?": "The set went all the way, then the sound system held {duration} of endless. Go again?",
  "Le set reprend là où tu l’as laissé.": "The set picks up where you left it.",
  "Le set se joue en paysage.": "The set plays in landscape.",
  "Le set s’arrête pour tout le monde plutôt que de continuer de travers. Le rapport est prêt pour « Ton avis ».": "The set stops for everyone rather than go on out of step. The report is ready in “Your feedback”.",
  "Le set s’arrête pour toute l’équipe, sans score : chacun peut changer de perso.": "The set stops for the whole team, with no score: everyone can change character.",
  "Le set va jusqu’au dernier boss, puis la nuit repart : elle s’arrête quand vous tombez.": "The set runs to the last boss, then the night takes off again: it ends when you fall.",
  "Le soleil se lève sur le dancefloor. Le sound system a tenu toute la nuit.": "The sun rises over the dancefloor. The sound system held all night long.",
  "Le sound system tient bon, mais les bad vibes ont vidé la piste. On se relève et on y retourne ?": "The sound system holds, but the bad vibes cleared the floor. Back on your feet and go again?",
  "Le totem envoie une onde sur chaque kick.": "The totem sends a wave on every kick.",
  "Les autres scènes suivent : à chaque sunrise, l’équipe choisit sa sortie.": "The other stages follow: at each sunrise, the team picks its exit.",
  "Les bad vibes ont eu raison du sound system. On rebranche et on y retourne ?": "The bad vibes got the better of the sound system. Plug back in and go again?",
  "Les bad vibes qu’il traverse encaissent plus de coups.": "Bad vibes it passes through take harder hits.",
  "Les bad vibes y ralentissent": "Bad vibes slow down in it",
  "Les bad vibes y sont marquées": "Bad vibes get marked in it",
  "Les deux versions de la partie ont divergé": "The two copies of the game drifted apart",
  "Les joueurs": "The players",
  "Les lucioles veillent sur toi": "The fireflies are watching over you",
  "Les pièges freinent les bad vibes": "Traps slow the bad vibes down",
  "Les quatre scènes, d’un chemin à l’autre": "All four stages, path after path",
  "Libre": "Free",
  "Lien copié, envoie-le à tes amis.": "Link copied, send it to your friends.",
  "Lien sélectionné : copie-le avec Ctrl+C.": "Link selected: copy it with Ctrl+C.",
  "Line-up": "Line-up",
  "Lourd et sûr de lui, il pousse ton matériel et encaisse moitié moins de face : prends-le à revers.": "Heavy and full of themselves, they push your gear and take half the damage from the front: hit them from behind.",
  "Lumière traversante": "Piercing Light",
  "Légendaire": "Legendary",
  "L’Avatar": "The Avatar",
  "L’Enraciné": "The Rooted",
  "L’after": "The afterparty",
  "L’hôte a fermé le salon": "The host closed the room",
  "L’hôte a quitté le set": "The host left the set",
  "L’hôte choisit la scène": "The host picks the stage",
  "L’équipe": "The team",
  "Machine à fumée": "Smoke Machine",
  "Main libre": "Free hand",
  "Main stage": "Main stage",
  "Maj": "Shift",
  "Maj droite": "Right Shift",
  "Maj+Tab": "Shift+Tab",
  "Manette": "Gamepad",
  "Manette {number}": "Gamepad {number}",
  "Marcher au stick droit, viser au gauche": "Walk with the right stick, aim with the left",
  "Marque": "Marks",
  "Menu de pause": "Pause menu",
  "Menu principal": "Main menu",
  "Mode calme": "Calm mode",
  "Mode calme, commandes, langue": "Calm mode, controls, language",
  "Mode de jeu": "Game mode",
  "Molette": "Wheel",
  "Molette ↑": "Wheel ↑",
  "Molette ↓": "Wheel ↓",
  "Monocycle": "Unicycle",
  "Monocycle filant": "Shooting Unicycle",
  "Monocycle réparateur": "Repair Unicycle",
  "Monter le son": "Turn the sound up",
  "Montée": "Build-up",
  "Musique et effets": "Music and effects",
  "Même écran": "Same screen",
  "Même écran ou en ligne": "Same screen or online",
  "Ne vise pas, il danse : sa bonne humeur frappe tout autour de lui et fait tirer plus vite.": "Doesn’t aim, just dances: their good mood hits all around them and makes everyone fire faster.",
  "Niv. {level}": "Lv. {level}",
  "Niveau": "Level",
  "Niveau supérieur": "Level up",
  "Niveau {level}": "Level {level}",
  "Niveau {level} : {vibes} vibes sur {next}": {
    "one": "Level {level}: {vibes} of {next} vibe",
    "other": "Level {level}: {vibes} of {next} vibes"
  },
  "Niveau {level} sur {max}": "Level {level} of {max}",
  "Nom": "Name",
  "Nom du joueur {number}": "Player {number}’s name",
  "Non": "Off",
  "Nouveau": "New",
  "Nouveau record !": "New record!",
  "Nova": "Nova",
  "Ola": "Wave",
  "Ola déchaînée": "Tidal Wave",
  "Ola sans fin": "Endless Wave",
  "Oui": "On",
  "Page ↑": "Page ↑",
  "Page ↓": "Page ↓",
  "Palier {tier} / {count}": "Tier {tier} / {count}",
  "Palier {tier}, drop": "Tier {tier}, drop",
  "Par où commence la nuit ?": "Where does the night start?",
  "Partie interrompue": "Game interrupted",
  "Pas chassé": "Chassé Step",
  "Pas de compte GitHub ? Copie ton avis pour l’envoyer autrement.": "No GitHub account? Copy your feedback to send it another way.",
  "Pas de réponse : réessaie, ou vérifie le code": "No answer: try again, or check the code",
  "Pas sur GitHub ?": "Not on GitHub?",
  "Passe dans les coulisses sur Discord": "Come backstage on Discord",
  "Pause": "Pause",
  "Pavé {number}": "Numpad {number}",
  "Phrases tenues": "Phrases held",
  "Piège précédent": "Previous trap",
  "Piège suivant": "Next trap",
  "Pièges": "Traps",
  "Place {place} sur {slots}": "Slot {place} of {slots}",
  "Pluie de diabolos": "Diabolo Rain",
  "Plus aucun signe de l’hôte depuis {seconds} secondes.": {
    "one": "No sign of the host for {seconds} second.",
    "other": "No sign of the host for {seconds} seconds."
  },
  "Plus de place pour un piège : reprends-en un": "No room for another trap: take one back",
  "Plus personne debout": "Nobody left standing",
  "Portée": "Range",
  "Pose ton mot sur Discord": "Drop us a line on Discord",
  "Pose un piège": "Drop a trap",
  "Poser le piège": "Drop the trap",
  "Poser un piège à ses pieds": "Drop a trap at your feet",
  "Pour rejouer ta partie à l’identique": "To replay your game exactly",
  "Progressive": "Progressive",
  "Projecteur de poursuite": "Follow Spot",
  "Prêt": "Ready",
  "Prête": "Ready",
  "Psychill, ambient": "Psychill, ambient",
  "Psytrance full-on": "Full-on psytrance",
  "Pumpui": "Pumpui",
  "Quelle nuit !": "What a night!",
  "Qui monte sur la piste ce soir ?": "Who hits the floor tonight?",
  "Quitter": "Leave",
  "Quitter la partie": "Quit the game",
  "Quitter le salon": "Leave the room",
  "Quitter le set ?": "Leave the set?",
  "Raconte-nous ta soirée": "Tell us about your night",
  "Ralentit": "Slows",
  "Rallonge": "Extension Cord",
  "Ramasse les vibes": "Pick up the vibes",
  "Rang {rank}": "Rank {rank}",
  "Rang {rank} sur {max}": "Rank {rank} of {max}",
  "Rare": "Rare",
  "Recharge": "Cooldown",
  "Recharge la page": "Reload the page",
  "Record : {score}": "Record: {score}",
  "Recrute tes roadies sur Discord": "Round up your roadies on Discord",
  "Rejoindre": "Join",
  "Rejouer": "Play again",
  "Relique": "Relic",
  "Relis ton avis dans le nouvel onglet, puis publie-le. Il te faut un compte GitHub.": "Read your feedback over in the new tab, then post it. You need a GitHub account.",
  "Remettre par défaut": "Reset to default",
  "Remplace {weapon}": "Replaces {weapon}",
  "Remplis ta jauge de vibes, puis choisis une amélioration": "Fill your vibes gauge, then pick an upgrade",
  "Repousse": "Pushes back",
  "Reprendre": "Resume",
  "Reprendre : {trap}": "Take back: {trap}",
  "Reste deux mesures pour brancher": "Two bars left to plug in",
  "Reste près d’une enceinte pour la brancher": "Stay near a speaker to plug it in",
  "Reste quatre mesures pour brancher": "Four bars left to plug in",
  "Reste trois mesures pour brancher": "Three bars left to plug in",
  "Reste une mesure pour brancher": "One bar left to plug in",
  "Reste zéro mesure pour brancher": "No bars left to plug in",
  "Reste {bars} mesures pour brancher": {
    "one": "{bars} bar left to plug in",
    "other": "{bars} bars left to plug in"
  },
  "Rester": "Stay",
  "Retour": "Back",
  "Retour arrière": "Backspace",
  "Retour au perso": "Back to the character",
  "Retour au salon": "Back to the lobby",
  "Retour au salon ?": "Back to the lobby?",
  "Retour au titre": "Back to the title",
  "Ruban arc-en-ciel": "Rainbow Ribbon",
  "Réessayer": "Try again",
  "Réglages": "Settings",
  "Salon": "Lobby",
  "Salon en ligne": "Online room",
  "Salon local": "Local lobby",
  "Salon plein": "Room full",
  "Sans fin": "Endless",
  "Sans lui, le sound system s’éteint.": "Without them, the sound system goes dark.",
  "Sans strobos, secousses ni halos forts": "No strobes, shakes or strong glows",
  "Sans tenir le tir": "Without holding fire",
  "Score": "Score",
  "Scène": "Stage",
  "Scène du départ": "Starting stage",
  "Scènes": "Stages",
  "Se déplacer": "Move",
  "Ses bulles de blabla s'affichent et masquent un bout de ton écran.": "Their chatter bubbles pop up and hide part of your screen.",
  "Ses zones freinent les bad vibes et soignent tes alliés.": "Its zones slow the bad vibes down and heal your allies.",
  "Soigne": "Heals",
  "Soigne, répare la scène et relève ses amis.": "Heals, repairs the stage and gets friends back up.",
  "Soin": "Heal",
  "Son": "Sound",
  "Son bâillement se propage autour de lui, puis il s'endort sur place.": "Their yawn spreads all around them, then they fall asleep on the spot.",
  "Son des coups": "Hit sound",
  "Sono de référence": "Reference Rig",
  "Souffle un cône de brume qui balaie la piste, soigne sur chaque temps et ralentit les bad vibes.": "Blows a cone of mist that sweeps the floor, heals on every beat and slows the bad vibes.",
  "Souris": "Mouse",
  "Spéciale": "Special",
  "Spéciale XXL": "Special XXL",
  "Stick droit": "Right stick",
  "Stick gauche": "Left stick",
  "Sub renforcé": "Boosted Sub",
  "Sunrise": "Sunrise",
  "Sunrise !": "Sunrise!",
  "Sur le drop, il traverse tout l’écran et marque tout.": "On the drop, it crosses the whole screen and marks everything.",
  "Sur le drop, une pluie de diabolos tombe sur tout l’écran.": "On the drop, diabolos rain down on the whole screen.",
  "Ta Ola frappe deux fois plus fort.": "Your wave hits twice as hard.",
  "Ta Ola frappe plus fort.": "Your wave hits harder.",
  "Ta Ola frappe trois fois plus fort.": "Your wave hits three times as hard.",
  "Ta spéciale frappe deux fois plus fort.": "Your special hits twice as hard.",
  "Ta spéciale frappe plus fort.": "Your special hits harder.",
  "Ta spéciale frappe trois fois plus fort.": "Your special hits three times as hard.",
  "Ta spéciale revient bien plus vite.": "Your special comes back much faster.",
  "Ta spéciale revient plus vite.": "Your special comes back faster.",
  "Ta spéciale revient presque aussitôt.": "Your special comes back almost at once.",
  "Ta spéciale revient presque en continu.": "Your special comes back almost non-stop.",
  "Tactile": "Touch",
  "Talkie-walkie": "Walkie-Talkie",
  "Temps": "Time",
  "Tes agrès : {places}": "Your props: {places}",
  "Tes pièges font deux fois et demie plus de dégâts.": "Your traps deal two and a half times the damage.",
  "Tes pièges font deux fois plus de dégâts.": "Your traps deal twice the damage.",
  "Tes pièges font plus de dégâts.": "Your traps deal more damage.",
  "Tes pièges frappent fort et loin, et tes loots abondent.": "Your traps hit hard and far, and your loot pours in.",
  "Tes pièges frappent plus fort et couvrent plus de piste.": "Your traps hit harder and cover more of the floor.",
  "Tes tirs font deux fois plus de dégâts.": "Your shots deal twice the damage.",
  "Tes tirs font nettement plus de dégâts.": "Your shots deal a lot more damage.",
  "Tes tirs font plus de dégâts.": "Your shots deal more damage.",
  "Tes tirs traversent deux bad vibes de plus.": "Your shots go through two more bad vibes.",
  "Tes tirs traversent quatre bad vibes de plus.": "Your shots go through four more bad vibes.",
  "Tes tirs traversent six bad vibes de plus.": "Your shots go through six more bad vibes.",
  "Tes tirs vont plus vite, traversent plus et frappent fort.": "Your shots fly faster, go through more and hit hard.",
  "Tient la ligne et attire les bad vibes. Lent.": "Holds the line and draws the bad vibes in. Slow.",
  "Tir automatique": "Auto fire",
  "Tire": "Shoot",
  "Tire sur les doubles croches {steps}": "Fires on sixteenths {steps}",
  "Tire sur les doubles croches {steps}, une mesure sur {bars}": {
    "one": "Fires on sixteenths {steps}, one bar in {bars}",
    "other": "Fires on sixteenths {steps}, one bar in {bars}"
  },
  "Tirer": "Shoot",
  "Toi": "You",
  "Toi · hôte": "You · host",
  "Ton Kiff au max double la force de ta bonne humeur.": "Your Bliss at max doubles the power of your good mood.",
  "Ton Kiff fait frapper ta bonne humeur nettement plus fort.": "Your Bliss makes your good mood hit a lot harder.",
  "Ton Kiff fait frapper ta bonne humeur plus fort.": "Your Bliss makes your good mood hit harder.",
  "Ton aura s’élargit nettement.": "Your aura widens a lot.",
  "Ton aura s’élargit.": "Your aura widens.",
  "Ton aura s’étend de moitié.": "Your aura grows by half.",
  "Ton avis": "Your feedback",
  "Ton avis sera public sur GitHub. N’y mets rien de personnel.": "Your feedback will be public on GitHub. Don’t put anything personal in it.",
  "Ton dash revient bien plus vite.": "Your dash comes back much faster.",
  "Ton dash revient nettement plus vite.": "Your dash comes back a lot faster.",
  "Ton dash revient plus vite.": "Your dash comes back faster.",
  "Ton message était trop long pour le lien, sa fin a été coupée. Copie-le en entier pour le coller sur GitHub.": "Your message was too long for the link, so its end was cut. Copy it whole to paste it on GitHub.",
  "Ton navigateur a bloqué le nouvel onglet. Réessaie, ou copie ton avis pour ne pas le perdre.": "Your browser blocked the new tab. Try again, or copy your feedback so you don’t lose it.",
  "Ton onglet a pris trop de retard.": "Your tab fell too far behind.",
  "Totem": "Totem",
  "Totem sono": "Sound Totem",
  "Touche le bouton de ta spéciale": "Tap your special’s button",
  "Touche le bouton du dash": "Tap the dash button",
  "Touche le bouton du piège pour le poser": "Tap the trap button to drop it",
  "Touche le bouton d’un piège pour le poser à tes pieds": "Tap a trap’s button to drop it at your feet",
  "Toucher": "Tap",
  "Toucher son bouton": "Tap its button",
  "Touches par défaut remises.": "Default keys restored.",
  "Toujours là : Start pour la pause, la croix pour les gestes, A et B dans les menus.": "Always there: Start to pause, the D-pad for emotes, A and B in the menus.",
  "Toujours là : Échap pour la pause, 1 à 5 pour les pièges, les flèches et Entrée dans les menus.": "Always there: Esc to pause, 1 to 5 for traps, the arrows and Enter in the menus.",
  "Tourne ton téléphone": "Turn your phone",
  "Trois cerceaux, chacun frappe comme ta spéciale.": "Three hoops, each hitting like your special.",
  "Trouve ton crew": "Find your crew",
  "Tu as rejoint le salon {code}.": "You joined room {code}.",
  "Tu attires les vibes de bien plus loin.": "You draw in vibes from much farther away.",
  "Tu attires les vibes de plus loin.": "You draw in vibes from farther away.",
  "Tu attires les vibes de très loin.": "You draw in vibes from very far away.",
  "Tu attires les vibes, tires plus et frappes plus fort.": "You draw in vibes, fire more and hit harder.",
  "Tu deviens plus solide et tu glisses plus vite.": "You get sturdier and glide faster.",
  "Tu fais venir les porteurs de loot deux fois plus souvent.": "Loot carriers show up twice as often.",
  "Tu fais venir les porteurs de loot plus souvent.": "Loot carriers show up more often.",
  "Tu fais venir les porteurs de loot trois fois plus souvent.": "Loot carriers show up three times as often.",
  "Tu files plus vite ; ta traînée freine plus et soigne mieux.": "You ride faster; your trail slows more and heals better.",
  "Tu fonces devant toi, intouchable, et les bad vibes alentour ne voient plus que toi.": "You charge ahead, untouchable, and the bad vibes around see only you.",
  "Tu gagnes 120 points de vie maximum.": "You gain 120 max health.",
  "Tu gagnes 40 points de vie maximum.": "You gain 40 max health.",
  "Tu gagnes 80 points de vie maximum.": "You gain 80 max health.",
  "Tu laisses les autres joueurs : ton personnage reste immobile et le set continue sans toi.": "You leave the others behind: your character stands still and the set goes on without you.",
  "Tu libères une onde de lumière qui repousse les bad vibes autour de toi.": "You release a wave of light that pushes back the bad vibes around you.",
  "Tu marches au stick droit et tu vises au gauche.": "You walk with the right stick and aim with the left.",
  "Tu marches au stick gauche et tu vises au droit.": "You walk with the left stick and aim with the right.",
  "Tu peux enchaîner deux dashs de plus.": "You can chain two more dashes.",
  "Tu peux enchaîner trois dashs de plus.": "You can chain three more dashes.",
  "Tu peux enchaîner un dash de plus.": "You can chain one more dash.",
  "Tu peux poser deux pièges de plus.": "You can drop two more traps.",
  "Tu peux poser quatre pièges de plus.": "You can drop four more traps.",
  "Tu peux poser six pièges de plus.": "You can drop six more traps.",
  "Tu ramasses les loots de bien plus loin.": "You pick up loot from much farther away.",
  "Tu ramasses les loots de plus loin.": "You pick up loot from farther away.",
  "Tu ramasses les loots de très loin.": "You pick up loot from very far away.",
  "Tu rentres avant le sunrise : la partie s’arrête ici, sans score.": "Heading home before sunrise: the game ends here, with no score.",
  "Tu roules vite ; ta traînée freine les bad vibes et soigne.": "You ride fast; your trail slows the bad vibes and heals.",
  "Tu sais jouer. Tiens jusqu’au sunrise !": "You know how to play. Hold on until sunrise!",
  "Tu soignes ceux qui sont près de toi et tu répares un peu la scène.": "You heal those near you and repair the stage a little.",
  "Tu te déplaces bien plus vite.": "You move much faster.",
  "Tu te déplaces nettement plus vite.": "You move a lot faster.",
  "Tu te déplaces plus vite.": "You move faster.",
  "Tu tires bien plus souvent.": "You fire much more often.",
  "Tu tires deux projectiles de plus.": "You fire two more projectiles.",
  "Tu tires nettement plus souvent.": "You fire a lot more often.",
  "Tu tires plus souvent et ta spéciale revient plus vite.": "You fire more often and your special comes back faster.",
  "Tu tires plus souvent.": "You fire more often.",
  "Tu tires quatre projectiles de plus.": "You fire four more projectiles.",
  "Tu tires six projectiles de plus.": "You fire six more projectiles.",
  "Un bâton, à jeter au feu": "A log, to toss on the fire",
  "Un cerceau tourne autour de toi, repousse et s’élargit.": "A hoop spins around you, pushes back and widens.",
  "Un joueur": "A player",
  "Un set, jusqu’au sunrise": "One set, until sunrise",
  "Une brume qui te soigne": "A mist that heals you",
  "Une idée, un bug ? Dis-le-nous": "An idea, a bug? Tell us",
  "Une note par coup porté": "A note for every hit",
  "Une onde de choc par kick": "A shockwave on every kick",
  "Une scène": "One stage",
  "Une vague part de toi, ralentit les bad vibes et fait courir et tirer plus vite toute l’équipe.": "A wave leaves you, slows the bad vibes and makes the whole team run and fire faster.",
  "Ventilateur brumisant": "Misting Fan",
  "Verr. maj": "Caps Lock",
  "Vers la bad vibe à portée": "At the bad vibe in range",
  "Vibes": "Vibes",
  "Vie": "Health",
  "Vie de la scène": "Stage health",
  "Viser": "Aim",
  "Viser et tirer": "Aim and shoot",
  "Visée automatique": "Auto aim",
  "Vitesse": "Speed",
  "Volume à fond": "Volume Maxed",
  "annuler": "cancel",
  "apprendre": "learn",
  "aucune": "none",
  "avant : {score}": "before: {score}",
  "avec {first} ou {second}, il fusionne": "with {first} or {second}, it fuses",
  "avec {upgrade}, devient {fusion}": "with {upgrade}, becomes {fusion}",
  "changer": "change",
  "choisir": "choose",
  "classe": "class",
  "classe, scène": "class, stage",
  "départ {stage} · {count} scènes · {length}": "from {stage} · {count} stages · {length}",
  "fermer": "close",
  "lancer": "start",
  "mode": "mode",
  "naviguer": "navigate",
  "niv. {level}": "lv. {level}",
  "ou rejoins le salon d’un ami": "or join a friend’s room",
  "pose le piège à tes pieds": "drop the trap at your feet",
  "quitter": "leave",
  "quitter sa place": "leave the seat",
  "recharge {duration}": "cooldown {duration}",
  "rejoindre": "join",
  "reprendre": "resume",
  "retour": "back",
  "sans fin": "endless",
  "scène": "stage",
  "son": "sound",
  "tant que vous tenez": "as long as you hold",
  "valider": "confirm",
  "vider": "clear",
  "{action} : appuie sur un bouton de la manette.": "{action}: press a gamepad button.",
  "{action} : appuie sur une touche, un bouton de la souris ou la molette.": "{action}: press a key, a mouse button or the wheel.",
  "{action} : case vidée.": "{action}: slot cleared.",
  "{action}, touche {number} : {key}": "{action}, slot {number}: {key}",
  "{count} alliés soignés": {
    "one": "{count} ally healed",
    "other": "{count} allies healed"
  },
  "{count} bad vibes": {
    "one": "{count} bad vibe",
    "other": "{count} bad vibes"
  },
  "{count} boss": {
    "one": "{count} boss",
    "other": "{count} bosses"
  },
  "{count} cartes": {
    "one": "{count} card",
    "other": "{count} cards"
  },
  "{count} vibes": {
    "one": "{count} vibe",
    "other": "{count} vibes"
  },
  "{count} visites": {
    "one": "{count} visit",
    "other": "{count} visits"
  },
  "{hp} sur {maxHp}": "{hp} of {maxHp}",
  "{key} va à {action} et quitte {other}.": "{key} goes to {action} and leaves {other}.",
  "{key} va à {action}, {other} prend {old}.": "{key} goes to {action}, {other} takes {old}.",
  "{key} va à {action}.": "{key} goes to {action}.",
  "{names} et {last}": "{names} and {last}",
  "{name} : {card}": "{name}: {card}",
  "{name} : {description}": "{name}: {description}",
  "{name} a quitté le set": "{name} left the set",
  "{name} choisit…": "{name} is choosing…",
  "{name}, dans le jeu complet": "{name}, in the full game",
  "{percent} %": "{percent}%",
  "{percent} %": "{percent}%",
  "{plugged} enceintes branchées sur {total}": {
    "one": "{plugged} of {total} speakers plugged in",
    "other": "{plugged} of {total} speakers plugged in"
  },
  "{role}, que tes agrès ne font pas encore": "{role}, which your props don’t do yet",
  "{skill} : en recharge": "{skill}: cooling down",
  "{skill} : prête": "{skill}: ready",
  "{taken}/{capacity}": "{taken}/{capacity}",
  "{value} sur {max}": "{value} of {max}",
  "{weapon} + {upgrade}": "{weapon} + {upgrade}",
  "{weapon}, niveau {level}": "{weapon}, level {level}",
  "À distance": "Remote",
  "À fond": "Full",
  "À plusieurs": "Together",
  "À terre": "Down",
  "Échap": "Esc",
  "Éclats de rire": "Belly Laughs",
  "Écran titre": "Title screen",
  "Écris ton avis avant de l’envoyer.": "Write your feedback before sending it.",
  "Équilibrage": "Balance",
  "Éventails de feu": "Fire Fans",
  "≈ {minutes} min": "≈ {minutes} min"
}
